define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/aspect",
    "csi",
    "csi/def",
    "csi/def/Field",
    "csi/locale"
], function(declare,lang,aspect,csi,def,Field,locale) {
    var CREATE_COLORWAYS = "CreateColorways";

    return declare(null, {

        _insertColorwaysField: function(/*csi.view.Widget*/view) {
            this.styleForm = view;

            view.insertField(lang.mixin(new Field(), {
                m_id: CREATE_COLORWAYS,
                m_typeControl: def.FIELD_CHECKBOX,
            }));

        }
    });
});